// Tela de login da versão web. Aparece quando `/api/snapshot` responde 401;
// ao autenticar, chama `aoEntrar` (que recarrega o app).

import { clear, el, botao } from "./ui.ts";
import { inputSenha } from "./screens/_cadastro.ts";
import { apiLogin } from "./api.ts";

export function telaLogin(root: HTMLElement, aoEntrar: () => void): void {
  clear(root);

  const login = el("input", {
    type: "text",
    autocomplete: "username",
    "aria-label": "Login",
  }) as HTMLInputElement;
  const senha = inputSenha("Sua senha", "current-password");
  const erro = el("p", { class: "form-erro", role: "alert" });
  const ok = botao("primario", { type: "submit" }, "Entrar");

  const form = el(
    "form",
    { class: "login-form" },
    el("img", {
      class: "gate-logo",
      src: "assets/logo-light.svg",
      alt: "Arco-Íris Lavanderia",
    }),
    el("label", { class: "campo" }, "Login", login),
    el("label", { class: "campo" }, "Senha", senha.element),
    erro,
    el("div", { class: "modal-actions" }, ok),
  );

  form.addEventListener("submit", (ev) => {
    ev.preventDefault();
    erro.textContent = "";
    ok.disabled = true;
    void apiLogin(login.value, senha.value)
      .then((r) => {
        if (r.ok) aoEntrar();
        else {
          erro.textContent = r.erro;
          ok.disabled = false;
          senha.limpar();
          senha.focus();
        }
      })
      .catch(() => {
        erro.textContent = "Sem conexão com o servidor. Tente de novo.";
        ok.disabled = false;
      });
  });

  root.append(el("div", { class: "gate" }, form));
  login.focus();
}
